var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M15 18L9 12L15 6","stroke":"currentColor","stroke-width":_vm.strokeWidth,"stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }